module.exports = "<pdf-viewer [src]=\"pdfSrc\" [render-text]=\"true\" [original-size]=\"false\" [autoresize]=\"true\" style=\"max-width: 100%; display:block\"></pdf-viewer>\n"


//////////////////
// WEBPACK FOOTER
// ./public/app/common/pdf-viewer/pdf-viewer.component.html
// module id = ./public/app/common/pdf-viewer/pdf-viewer.component.html
// module chunks = main